import React from 'react';
import { LockOutlined } from '@mui/icons-material';
import {
  Chip,
  Tooltip,
} from '@mui/material';
import PropTypes from 'prop-types';
import {
  isQuickBooksReserved,
  quickBooksReservationMessage,
} from '../../utils/quickBooksReservation';

const QuickBooksReservation = ({ billable }) => {
  if (!isQuickBooksReserved(billable)) return null;
  return (
    <Tooltip title={quickBooksReservationMessage}>
      <Chip
        icon={<LockOutlined />}
        label="QuickBooks"
        aria-label="Reserved for QuickBooks"
        size="small"
        variant="outlined"
        tabIndex={0}
      />
    </Tooltip>
  );
};

QuickBooksReservation.propTypes = { billable: PropTypes.object.isRequired };

export default QuickBooksReservation;
